const Config = {
  context: "portal",
  channel: "portal",
  entityMapping: {
    MBSB: "MBS",
    Alliance: "AIS",
    HSBC: "BCA",
  },
  entity: {
    hsbc: {
      code: "BCA",
      logo: "HSBCLogo.png",
      route: "HSBC",
      designationTitle: true,
    },
    alliance: {
      code: "AIS",
      logo: "AllianceLogo.png",
      route: "Alliance",
      designationTitle: false,
    },
    mbsb: {
      code: "MBS",
      logo: "MBSBLogo.png",
      route: "MBSB",
      designationTitle: false,
    },
  },
  locale: {
    en: "EN",
    bm: "BM",
  },
  modules: {
    dashboardOverall: "dashboard-overall",
    dashboardUpcoming: "dashboard-upcoming",
    proposal: "proposal",
    issuedCase: "issuedCase",
    claim: "claim",
    certificateCollection: "certificateCollection",
    certificateCollectionUpcoming: "certificateCollection-upcoming",
    businessOpportunity: "businessOpportunity",
    businessOpportunityUpcoming: "businessOpportunity-upcoming",
    form: "form",
  },
  proposal: {
    actions: {
      SUBMITTED: {
        codes: ["viewProposal", "viewQuotation"],
        labels: ["View Proposal", "View Quotation"],
        // labels: [Labels.LBL_VIEW_PROPOSAL, Labels.LBL_VIEW_QUOTATION],
        urls: ["proposal", "quotation"],
      },
      PENDING_SUBMISSION: {
        codes: ["viewProposal", "viewQuotation"],
        labels: ["View Proposal", "View Quotation"],
        // labels: [Labels.LBL_VIEW_PROPOSAL, Labels.LBL_VIEW_QUOTATION],
        urls: ["proposal", "quotation"],
      },
      PENDING_REVIEW: {
        codes: ["updateProposal", "viewQuotation", "updateProposal"],
        labels: ["Update Proposal", "View Quotation", "Delete Proposal"],
        // labels: [
        //   Labels.LBL_VIEW_PROPOSAL,
        //   Labels.LBL_VIEW_QUOTATION,
        //   Labels.LBL_UPDATE_PROPOSAL,
        // ],
        urls: ["proposal", "quotation", "proposal_steps/provide_details"],
      },
      DRAFT: {
        codes: ["updateProposal", "viewQuotation", "deleteProposal"],
        labels: ["Update Proposal", "View Quotation", "Delete Proposal"],
        // labels: [
        //   Labels.LBL_UPDATE_PROPOSAL,
        //   Labels.LBL_DELETE_PROPOSAL,
        //   Labels.LBL_VIEW_QUOTATION,
        // ],
        urls: ["proposal_steps/provide_details", "/", "quotation"],
      },
      UNDEFINED: {
        codes: ["Undefined"],
        labels: ["Undefined"],
        urls: [""],
      },
    },
    formStepData: [
      {
        header: 'Step 1 - Provide Details',
        subheader: 'Please fill in the details and ensure the information you provided is correct',
      },
      {
        header: 'Step 2 - Upload Documents',
        subheader: 'Attach documents, or images to the proposal ',
      },
      {
        header: 'Step 3 - Review ',
        subheader: 'Please review the details and ensure the information you provided is correct',
      },
      {
        header: 'Step 4 - Consent and Declaration',
        subheader: 'Please review the details and ensure the information you provided is correct',
      }
    ],
    formDataMapping: {
      step1: {
        header: 'Step 1 - Provide Details',
        subheader: 'Please fill in the details and ensure the information you provided is correct',
        personalDetailsTitle: 'Personal Details',
        mortgageDetailsTitle: 'Mortgage Details',
        creditCardDetailsTitle: 'Credit Card Payment Details',
        healthStatementTitle: 'Health Statement',
        personalInformationOfPayorTitle: 'Personal Information of the Payor',
        payorInformationTitle: 'Personal Information of the Payor',
        directCreditDetailsTitle: 'Direct Credit Details',
        extendedHealthDeclarationTitle: 'Extended Health Declaration',
        foreignQuestionaireTitle: 'Foreign\'s Questionnaire',
        residentailForeignTravelTitle: 'Residential and Foreign Travel Questionnaire',
        generalOccupationTitle: 'General Occupational Questionnaire',
        oilGasTitle: 'Oil and Gas Occupational Questionnaire',
        representativeFormTitle: {
          name: 'Representative\'s Name',
          branchCode: 'Branch Code',
          staffCode: 'Staff Code',
          proposalDate: 'Proposal Date',
        },
        personCoveredFormTitle: {
          name: 'Full Name (as in NRIC / Other identity document)',
          gender: 'Gender',
          title: 'Title',
          idType: 'ID Type',
          icNo: 'IC No.',
          addIDType: 'Additional ID Type',
          oldIdNo: 'Old IC No.',
          birthCertNo: 'Birth Certificate No.',
          dob: 'Date of Birth',
          maritalStatus: 'Marital Status',
          race: 'Race',
          religion: 'Religion',
          isMalaysian: 'Are you a Malaysian',
          nationality: 'Nationality',
          placeOfBirth: 'Place of Birth',
          isLivingInMalaysia: 'Currently Living in Malaysia',
          country: 'Country',
          correspondenceAddress: 'Correspondence Address',
          state: 'State',
          postcode: 'Postcode',
          city: 'City',
          isPermamentAddressCorrespondenceAddress: 'Permanent Address is same as Correspondence Address?',
          isResidentialAddressCorrespondenceAddress: 'Residential Address is same as Correspondence Address?',
          permanentAddress: 'Permanent Address',
          residentialAddress: 'Residential Address',
          occupation: 'Occupation',
          occupationClass: 'Occupation Class',
          annualIncome: 'Annual Income',
          exactAnnualIncome: 'Exact Annual Income',
          natureBusiness: 'Nature of Business',
          exactDuties: 'Exact Duties',
          mobileNo: 'Mobile Number',
          officePhoneNo: 'Office Phone Number',
          homePhoneNo: 'Home Phone Number',
          email: 'E-mail',
          companyName: 'Employer or Company Name',
          companyAddress: 'Employer or Company Address',
          companyCountry: 'Country of Employment',
          companyState: 'State',
          companyPostcode: 'Postcode',
          companyCity: 'City',
          preferContactMode: 'Preferred Contact Mode',
          isPayorPersonCovered: 'Is the Contributor same as the Person Covered?',
          relationshipToPersonCovered: 'Relationship to the Person Covered',
          specifyRelationship: 'Specify Relationship',
        },
        mortgageFormTitle: {
          financingInstitution: 'Financing Institution',
          financingRefNo: 'Financing Reference No.',
          financed: 'Financed',
          financingAmount: 'Financing Amount',
          loanTerm: 'Loan term ',
          defermentPeriod: 'Deferment Period',
          coverageTerm: 'Coverage Term',
          benefit: 'Death and Total & Permanent Disability Benefit',
          criticalIllnessSumCovered: 'Critical Illness Sum Covered',
          initialSumCovered: 'Initial Sum Covered ',
          contributionAmount: 'Contribution Amount ',
        },
        healthStatementFormTitle: {
          s1: 'I have ever had, received medical advice or treatment for: cancer, chest pain, heart attack, stroke, diabetes mellitus, Hepatitis B or C, HIV infection, loss of hearing, loss of vision (other than vision corrected by prescription lens), any physical disability or any condition of the heart, lungs, liver, kidney, digestive system, mental or nervous system.',
          s2: 'In the last 2 years, I have had any other condition resulting in repeated consultations or follow-up with a doctor, specialist or hospital or continuously receiving medication for 14 days or more.',
          s3: 'I am currently planning or been advised, to consult a doctor or undergoing investigation or awaiting the results of medical tests or follow-up.',
        },
        directCreditFormTitle: {
          accountHolderName: 'Account Holder’s Name',
          bankName: 'Bank Name',
          bankAccNo: 'Bank Account No.',
          termsCondition: 'I have read the Direct credit Terms and Conditions.'
        },
        creditCardPaymentFormTitle: {
          cardHolderName: 'Card Holder’s Name',
          creditCardNo: 'Credit Card No.',
          creditCardType: 'Credit Card Type',
          creditCardExpiryDate: 'Card Expiry Date',
          bank: 'Card Issuing Bank',
        },
        extendedHealthFormTitle: {
          height: 'Height',
          weight: 'Weight',
          isSmoker: 'Have you smoked cigarettes (including electronic cigarettes) or tobacco in the past 12 months?',
          isDiagnosed: 'Have you ever been diagnosed with or had symptoms of any of the following? If your answer is Yes, you are required to provide full details.',
          isConsultOrTreatment: 'Aside from what you’ve already told us, in the past 5 years have you had any other condition which has resulted in ongoing specialist consultation; hospitalization or continuous medical treatment for 14 days or longer?',
          isInvestigateOrOperation: 'Are you currently under investigation, awaiting a surgical operation or the results of any medical tests; or in the past 3 months experienced any symptoms such as : prolonged fatigue for more than 7 days, unexplained weight loss of more than 5kg, abnormal lump, growth or swelling, blood in urine, stools or coughing, new persistent pain ?',
          hasGeneticDisorder: 'Have either of your parents or siblings, before age 60, been diagnosed with any of the following: coronary heart disease, cancer or the breast, ovaries, colon or rectum, diabetes, familial polyposis, polycystic, kidney disease, multiple sclerosis, Huntington’s disease, Parkinson’s disease or motor neuron disease?',
          hasHeartDisease: 'Heart attack, coronary artery disease, heart valve disorder or heart murmur.',
          highBloodPressure: 'High blood pressure or raised cholesterol.',
          mentalIllness: 'Stroke, epilepsy, depression or mental illness.',
          isCancer: 'Cancer, abnormal growth or tumor.',
          isHIV: 'HIV infection or AIDS.',
          isDiabetes: 'Diabetes or raised blood sugar.',
          isPulmonaryDisease: 'Asthma, tuberculosis, pneumonia or chronic obstructive pulmonary disease.',
          isLiverDisease: 'Hepatitis B or C, fatty liver, elevated liver enzymes or liver cirrhosis.',
          isKidneyDisease: 'Kidney failure or abnormal kidney function.',
          lossSenses: 'Deafness or loss of hearing, blindness or loss of vision (excluding prescription lens to correct vision)',
          physicalDisability: 'Arthritis, recurrent back pain, injury or disorder of the spine, muscles, tendons, limbs, bones or joints or other physical disability.',
          prolongedFatigue: 'Prolonged fatique for more than 7 days.',
          unexplainedLossWeight: 'Unexplained weight loss of more than 5kg.',
          abnormalLump: 'Abnormal lump, growth or swelling.',
          bloodInUrine: 'Blood in urine, stools or coughing.',
          newPersistentPain: 'New persistent pain.',
          pregnancyMonth: 'How many months?',
          medicalCondition: 'Medical Condition',
          diagnosisDate: 'Date of Diagnosis',
          treatmentPrescribed: 'Treatment Prescribed',
          doctorName: 'Attending Doctor\'s Name',
          doctorAddress: 'Attending Doctor\'s Address',
          country: 'Country',
          state: 'State',
          postcode: 'Postcode',
          city: 'City',
          isPregnant: 'Are you currently pregnant?',
          pregnancyMonth: 'How many months?',
        },
        foreignQuestionaireFormTitle: {
          stayDuration: 'How long do you intend to stay in Malaysia?',
          weight: 'Weight',
          statusInMalaysia: 'What is your official status in Malaysia?',
          otherStatusInMalaysia: 'Please Specify',
          positionNduties: 'Current positions in company and exact duties?',
          bankOrProperty: 'Do you have the followig based in Malaysia?',
          isSpouseMalaysian: 'Is your spouse a Malaysian?',
          spouseOccupation: 'Occupation',
          spouseNationality: 'Select Nationality',
          familyMember: 'Does your spouse (and any children) family reside with you?',
          isTravel: 'Do you intend to travel to any other country (or returning to your home) at any stage?',
          reasonForCert: 'Why do you need a Malaysian class certificate and what do you intend to do with the certificate when you leave Malaysia?',
          hasGeneticDisorder: 'Have either of your parents or siblings, before age 60, been diagnosed with any of the following: coronary heart disease, cancer or the breast, ovaries, colon or rectum, diabetes, familial polyposis, polycystic, kidney disease, multiple sclerosis, Huntington’s disease, Parkinson’s disease or motor neuron disease?',
          isPregnant: 'Are you currently pregnant?',
          pregnancyMonth: 'How many months?',
          medicalCondition: 'Medical Condition',
          diagnosisDate: 'Date of Diagnosis',
          treatmentPrescribed: 'Treatment Prescribed',
          doctorName: 'Attending Doctor’s Name',
          doctorAddress: 'Attending Doctor’s Address',
          country: 'Country',
          state: 'State',
          postcode: 'Postcode',
          city: 'City',
        },
        oilGassTitle: {
          occupation: "Occupation",
          exactDuties: "Exact Duties",
          jobScope: "Does your job involve :",
          workingDuration: "How long have you been working in this occupation?",
          isHazardousDuties: "Are there any other hazardous duties involved?",
          isAccident: "Have you ever had an accident whilst performing the above duties?",
          rigLocation: "Where is the rig situated?",
          travelFreqToRig: "How often do you travel to the oil rig per annum?",
          transportMode: "What is the mode of transport used?",
          helicopterToRigDuration: "State duration of the journey to oil rig :",
          helicopterToRigFreq: "Frequency of travel :",
        },
        residentailForeignTravelFormTitle: {
          stayDuration: 'Duration of residence or travel.',
          residenceOrTravelAddress: 'Residence/Travel Address',
          residenceOrTravelCountry: 'Country of Residence/Travel',
          travelStayDuration: 'How long will you travel for or how long will you stay?',
          isFirstEMploymentReason: 'Is this your first visit abroad for employment reason?',
          isStayThroughout: 'Will you be remaining at this location throughout your stay / travel?',
          notStayThroughoutAddress: 'Where else will you be staying?',
          typeOfStay: 'Where are you staying?',
          acommodationLocated: 'Where is your accommodation located?',
          otherAccommodationType: 'Please specify',
          liveWorkCondition: 'How would describe the living and working conditions (including the ventilation and sanitary condition)?',
          politicalSituation: 'How would describe the political situation in your country of destination?',
        },
        generalOccupationDetailsData: {
          occupation: "What is your occupation and industry you engage in?",
          jobScope: "Does your job involve :",
          isAccident: "Have you ever had an accident while performing your work duty?",
          isHealtAffectedByOcc: "Have your heatlh ever affected by the occupation?",
          workingDuration: "How long have you been working in this occupation?",
          isChangeWork: "Do you intend to change the nature of the work you perform in the next twelve months?",
        }

      },
      personalDetailsData: {
        occupationClass: '',
        smoker: '',
        idType: {
          code: ''
        },
        occupation: '',
        otherIdNo: '',
        gender: '',
        anb: '',
        dob: '',
        name: '',
        natureOfBusiness: '',
        idNo: '',
        addIDType: '',
        quotationDate: '',
        representativeName: '',
        branchCode: '',
        staffCode: '',
        staffIcNo: '',
        staffPhone: '',
        staffEmail: '',
        proposalDate: '',
        title: '',
        maritalStatus: '',
        race: '',
        raceOthers: '',
        religion: '',
        malaysian: '',
        otherNationality: '',
        placeOfBirth: '',
        currentLivingInMalaysia: '',
        country: '',
        state: '',
        city: '',
        corrCountry: '',
        corrAddress: '',
        corrState: '',
        corrPostcode: '',
        corrCity: '',
        permanentAddrSameAsCorrAddr: '',
        permanentAddr: '',
        residentialAddrSameAsCorrAddr: '',
        residentialAddr: '',
        annualIncome: '',
        exactDuties: '',
        mobileNumber: '',
        officePhoneNumber: '',
        email: '',
        employerName: '',
        employerAddr: '',
        employerCountry: '',
        employerState: '',
        employerPostcode: '',
        employerCity: '',
        preferContactEmail: '',
        preferContactMobile: ''
      },
      healthDetailsData: {
        q1: '',
        q2: '',
        q3: '',
      },
      payorInformationData: {
        isPayorPersonCovered: '',
        relationshipToPersonCovered: '',
        specifyRelationship: '',
        occupationClass: '',
        idType: {
          code: ''
        },
        occupation: '',
        otherIdNo: '',
        dob: '',
        name: '',
        natureOfBusiness: '',
        idNo: '',
        addIDType: '',
        nationality: '',
        country: '',
        corrCountry: '',
        corrAddress: '',
        corrState: '',
        corrPostcode: '',
        corrCity: '',
        residentialAddrSameAsCorrAddr: '',
        residentialAddr: '',
        annualIncome: '',
        exactAnnualIncome: '',
        mobileNumber: '',
        officePhoneNumber: '',
        homePhoneNumber: '',
        email: '',
        employerName: '',
        employerAddr: '',
        employerCountry: '',
        employerState: '',
        employerPostcode: '',
        employerCity: '',
      },
      creditCardPaymentData: {
        issueBankCode: "",
        isTermsAndConditionChecked: "",
        isAuthorisedChecked: "",
        creditCardType: "",
        creditCardNo: "",
        creditCardExpiryDate: "",
        cardHolderName: "",
      },
      generalOccupationDetailsData: {
        occIndustryEngage: "",
        natureOfOccupation: "", //change 
        liftingHeavy: "",
        undergroundHeight: "",
        chemicalWorking: "",
        highVoltage: "",
        machinerary: "",
        vesselWorking: "",
        travel: "",
        env: "",
        accident: "",
        affectHealth: "",
        yearsWorking: "",
        switchJob: "",
      },
      foreignDetailsData: {
        arrivalDate: "",
        yearStay: "", //change 
        officialStatus: "",
        officialStatusDetails: "",
        positionExactDuties: "",
        bankAccount: "",
        bankAccouuntDetails: "",
        property: "",
        propertyDetails: "",
        business: "",
        businessDetails: "",
        investment: "",
        investmentDetails: "",
        relatives: "",
        relativesDetails: "",
        spouseMalaysian: "",
        spouseOccupation: "",
        spouseNationality: "",
        spouseReside: "",
        intendTravel: "",
        intendTravelDetails: "",
        certReason: "",
      },
      oilAndGasDetailsData: {
        occIndustryEngage: "",
        natureOfOccupation: "",
        yearsWorking: "",
        lifting: "",
        liftingDetails: "",
        chemical: "",
        chemicalDetails: "",
        equipment: "",
        equipmentDetails: "",
        explosive: "",
        explosiveDetails: "",
        voltage: "",
        voltageDetails: "",
        underwater: "",
        hazard: "",
        hazardDetails: "",
        accident: "",
        accidentDetails: "",
        rigSituated: "",
        travelToOilRigPerAnnum: "",
        transportHelicopter: "",
        transportHelicopterDurationHour: "",
        transportHelicopterFreqTravel: "",
        transportOther: "",
      },
      residentialDetailsData: {
        durationOfResidence: "",
        residenceAddr: "",
        residenceCountry: "",
        state: "",
        postcode: "",
        city: "",
        stay: "",
        firstVisit: "",
        firstVisitDetails: "",
        locationRemaining: "",
        otherStayAddr: "",
        otherStayCountry: "",
        otherStayState: "",
        otherStayPostcode: "",
        otherStayCity: "",
        accomType: "",
        otherAccomTypeDetails: "",
        accomLocated: "",
        workingCond: "",
        politicCond: "",
      },
      extendedHealthDetailsData: {
        q1: '',
        q2: '',
        q3: '',
        q4a: '',
        q4b: '',
        q4c: '',
        q4d: '',
        q4e: '',
        q4f: '',
        q4g: '',
        q4h: '',
        q4i: '',
        q4j: '',
        q4k: '',
        q5: '',
        q6a: '',
        q6b: '',
        q6c: '',
        q6d: '',
        q6e: '',
        q7: '',
        q8: '',
        details: {
          questionNo: '',
          condition: '',
          dateOfDiagnosis: '',
          treatment: '',
          doctorName: '',
          doctorAddress: '',
          country: '',
          state: '',
          postcode: '',
          city: '',
        }
      },
      directCreditData: {
        accountHolderName: '',
        bankAccountNo: '',
        bankCode: '',
      },
      clientConsentDetails: {
        id: '',
        title: '',
        desc: '',
        status: '',
        compulsory: 'Yes',
      }
    },
    dataTableCollumnMapping: [
      {
        title: 'Ref No.',
        key: "refNo",
        dataIndex: "refNo",
      },
      {
        title: 'Proposal No.',
        key: "proposalNo",
        dataIndex: "proposalNo",
      },
      {
        title: 'Client Name',
        key: "fullName",
        dataIndex: "fullName",
      },
      {
        title: 'ID No.',
        key: "idNo",
        dataIndex: "idNo",
      },
      {
        title: 'Created On',
        key: "cms_createdOn",
        dataIndex: "cms_createdOn",
      },
      {
        title: 'Last Updated',
        key: "cms_updatedOn",
        dataIndex: "cms_updatedOn",
      },
      {
        title: 'Status',
        key: "trxStatus",
        dataIndex: "trxStatus",
      },
      {
        title: "",
        key: "action",
        dataIndex: "action",
      },
    ],
    dataMapping: {
      body: [
        {
          item: {
            caption: 'Ref No.',
            value: "refNo",
          },
        },
        {
          item: {
            caption: 'ID No.',
            value: "id",
          },
        },
        {
          item: {
            caption: 'Proposal No.',
            value: "proposalNo",
          },
        },
      ],
      footer: [
        {
          item: {
            caption: 'Creation Date',
            value: "cms_createdOn",
          },
        },
        {
          item: {
            caption: 'Last Updated',
            value: "cms_updatedOn",
          },
        },
      ],
    },
    tabBarMapping: {
      all: {
        label: 'All',
        value: "ALL",
      },
      submitted: {
        label: 'Submitted',
        value: "SUBMITTED",
      },

      pendingSubmission: {
        label: 'Pending Submission',
        value: "PENDING_SUBMISSION",
      },
      pendingReview: {
        label: 'Pending Review',
        value: "PENDING_REVIEW",
      },
      draft: { label: 'Draft', value: "DRAFT" },
    },
    dataDetailMapping: {
      personalDetails: [
        {
          caption: 'Representative\'s Details'
        },
        {
          item1: "representativeName",
          item2: "branchCode",
        },
        {
          item1: "staffCode",
          item2: "proposalDate",
        },
        {
          divide: true,
        },
        {
          caption: 'Person to be Covered\'s Details'
        },
        {
          item1: "name",
          item2: "gender",
        },
        {
          item1: "title",
        },
        {
          item1: "idType",
          item2: "idNo",
        },
        {
          item1: "addIDType",
          item2: "addIDNo",
        },
        {
          item1: "dob",
          item2: "maritalStatus",
        },
        {
          item1: "race",
          item2: "religion",
        },
        {
          item1: "isMalaysian",
          item2: "pob",
        },
        {
          item1: "isLivingMalaysia",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "correspondenceAddress",
        },
        // {
        //   item1: "isPermanentAddressSameAsCorrespondenceAddress",
        //   item2: 'permanentAddress'
        // },
        {
          item1: "isResidentialAddressSameAsCorrespondenceAddress",
          item2: 'residentialAddress'
        },
        {
          item1: "occupation",
          item2: "natureOfBusiness",
        },
        {
          item1: "annualIncome",
          item2: "exactAnnualIncome",
        },
        {
          item1: "exactDuties",
        },
        {
          item1: "officePhoneNumber",
          item2: "homePhoneNumber",
        },
        {
          item1: "mobileNumber",
          item2: "email",
        },
        {
          item1: "companyName",
          item2: "companyAddress",
        },
      ],
      mortgageDetails: [
        {
          item1: "financingBank",
          item2: "financingRefNo",
        },
        {
          item1: "financed",
          item2: "financingAmount",
        },
        {
          item1: "loanTerm",
          item2: "defermentPeriod",
        },
        {
          item1: "coverageTerm",
        },
        {
          item1: "benefit",
          item2: "criticalIllnessSumCovered",
        },
        {
          item1: "initialSumCovered",
          item2: "contributionAmount",
        },
      ],
      creditCardPayment: [
        {
          item1: "cardHolderName",
          item2: "creditCardNo",
        },
        {
          item1: "creditCardType",
          item2: "creditCardExpiryDate",
        },
        {
          item1: "issueBankCode",
        },
      ],
      healthStatement: [
        {
          fullWidth: true,
          item1: "isDiagnosedDisease",
        },
        {

          fullWidth: true,
          item1: "isConsultation",
        },
        {
          fullWidth: true,
          item1: "isFollowUp",
        },
      ],
      directCreditDetails: [
        {
          item1: "accountHolderName",
          item2: "bankAccNo",
        },
        {
          item1: "bankName",
        },
      ],
      payorInformation: [
        {
          item1: "isPayorPersonCovered",
        },
        {
          item1: "relationshipToPersonCovered",
          item2: "specifyRelationship",
        },
        {
          item1: "name",
        },
        {
          item1: "idType",
          item2: "idNo",
        },
        {
          item1: "addIDType",
          item2: "addIDNo",
        },
        {
          item1: "dob",
        },
        {
          item1: "nationality",
        },
        {
          item1: "occupation",
          item2: "occupationClass",
        },
        {
          item1: "annualIncome",
          item2: "exactDuties",
        },
        {
          item1: "companyName",
          item2: "natureOfBusiness",
        },
        {
          item1: "companyAddress",
          item2: "companyCountry",
        },
        {
          item1: "companyState",
          item2: "companyPostcode",
        },
        {
          fullWidth: true,
          item1: "correspondenceAddress",
        },
        {
          item1: "isResidentialAddressSameAsCorrespondenceAddress",
          item2: 'residentialAddress'
        },
        {
          item1: "officePhoneNumber",
          item2: "homePhoneNumber",
        },
        {
          item1: "mobileNumber",
          item2: "email",
        },
      ],
      foreigner: [
        {
          item1: "arrivalDate",
          item2: "yearStay",
        },
        {
          item1: "officialStatus"
        },
        {
          indent: true,
          item1: "officialStatusDetails"
        },
        {
          item1: "positionExactDuties",
        },
        {
          item1: "property",
        },
        {
          indent: true,
          item1: "propertyDetails",
        },
        {
          item1: "spouseMalaysian",
        },
        {
          indent: true,
          item1: "spouseOccupation",
          item2: "spouseNationality",
        },
        {
          item1: "spouseReside",
        },
        {
          item1: "intendTravel",
        },
        {
          indent: true,
          item1: "intendTravelDetails",
        },
        {
          item1: "certReason",
        },
      ],
      generalOcc: [
        {
          item1: "occIndustryEngage",
        },
        {
          item1: "liftingHeavy",
        },
        {
          indent: true,
          item1: "liftingHeavyDetails",
        },
        {
          item1: "undergroundHeight",
        },
        {
          indent: true,
          item1: "undergroundHeightDetails",
        },
        {
          item1: "chemicalWorking",
        },
        {
          indent: true,
          item1: "chemicalWorkingDetails",
        },
        {
          item1: "highVoltage",
        },
        {
          indent: true,
          item1: "highVoltageDetails",
        },
        {
          item1: "machinerary",
        },
        {
          indent: true,
          item1: "machineraryDetails",
        },
        {
          item1: "vesselWorking",
        },
        {
          indent: true,
          item1: "vesselWorkingDetails",
        },
        {
          item1: "travel",
        },
        {
          indent: true,
          item1: "travelDetails",
        },
        {
          item1: "env",
        },
        {
          indent: true,
          item1: "envDetails",
        },
        {
          item1: "accident",
        },
        {
          indent: true,
          item1: "accidentDetails",
        },
        {
          item1: "affectHealth",
        },
        {
          indent: true,
          item1: "affectHealthDetails",
        },
        {
          item1: "yearsWorking",
        },
        {
          item1: "switchJob",
        },
        {
          indent: true,
          item1: "switchJobDetails",
        },
      ],
      residentialForeignTravel: [
        {
          item1: "durationOfResidence",
        },
        {
          item1: "residenceAddr",
        },
        {
          item1: "stayTime",
        },
        {
          item1: "firstVisit",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "firstVisitDetails",
        },
        {
          item1: "locationRemaining",
        },
        {
          indent: true,
          item1: "otherStayAddr",
        },
        {
          item1: "accomType",
          item2: "accomLocated",
        },
        {
          item1: "workingCond",
          item2: "politicCond",
        },
      ],
      oilAndGasOcc: [
        {
          item1: "occIndustryEngage",
        },
        {
          item1: "natureOfOccupation",
        },
        {
          item1: "yearsWorking",
        },
        {
          item1: "lifting",
        },
        {
          indent: true,
          item1: "liftingDetails",
        },
        {
          item1: "chemical",
        },
        {
          indent: true,
          item1: "chemicalDetails",
        },
        {
          item1: "equipment",
        },
        {
          indent: true,
          item1: "equipmentDetails",
        },
        {
          item1: "explosive",
        },
        {
          indent: true,
          item1: "explosiveDetails",
        },
        {
          item1: "voltage",
        },
        {
          indent: true,
          item1: "voltageDetails",
        },
        {
          item1: "underwater",
        },
        {
          item1: "underwaterDetails",
        },
        {
          item1: "hazard",
        },
        {
          indent: true,
          item1: "hazardDetails",
        },
        {
          item1: "accident",
        },
        {
          indent: true,
          item1: "accidentDetails",
        },
        {
          item1: "rigSituated",
        },
        {
          item1: "travelToOilRigPerAnnum",
        },
        {
          item1: "transportHelicopter",
        },
        {
          indent: true,
          item1: "transportHelicopterDurationHour",
          item2: "transportHelicopterFreqTravel",
        },
        {
          item1: "otherTransport",
        },
      ],
      uploaded_document: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
      ],
    },
    mobileDataDetailMapping: {
      personalDetails: [
        {
          caption: 'Representative\'s Details'
        },
        {
          fullWidth: true,
          item1: "representativeName",
        },
        {
          fullWidth: true,
          item1: "branchCode",
        },
        {
          fullWidth: true,
          item1: "staffCode",
        },
        {
          fullWidth: true,
          item1: "proposalDate",
        },
        {
          divide: true,
        },
        {
          caption: 'Person to be Covered\'s Details'
        },
        {
          fullWidth: true,
          item1: "name",
        },
        {
          fullWidth: true,
          item1: "gender",
        },
        {
          fullWidth: true,
          item1: "title",
        },
        {
          fullWidth: true,
          item1: "idType",
        },
        {
          fullWidth: true,
          item1: "idNo",
        },
        {
          fullWidth: true,
          item1: "dob",
        },
        {
          fullWidth: true,
          item1: "maritalStatus",
        },
        {
          fullWidth: true,
          item1: "race",
        },
        {
          fullWidth: true,
          item1: "religion",
        },
        {
          fullWidth: true,
          item1: "isMalaysian",
        },
        {
          fullWidth: true,
          item1: "pob",
        },
        {
          fullWidth: true,
          item1: "isLivingMalaysia",
        },
        {
          fullWidth: true,
          item1: "correspondenceAddress",
        },
        {
          fullWidth: true,
          item1: "isPermanentAddressSameAsCorrespondenceAddress",
        },
        {
          fullWidth: true,
          item1: 'permanentAddress'
        },
        {
          fullWidth: true,
          item1: "isResidentialAddressSameAsCorrespondenceAddress",
        },
        {
          fullWidth: true,
          item1: 'residentialAddress'
        },
        {
          fullWidth: true,
          item1: "occupation",
        },
        {
          fullWidth: true,
          item1: "natureOfBusiness",
        },
        {
          fullWidth: true,
          item1: "annualIncome",
        },
        {
          fullWidth: true,
          item1: "exactDuties",
        },
        {
          fullWidth: true,
          item1: "mobileNumber",
        },
        {
          fullWidth: true,
          item1: "officePhoneNumber",
        },
        {
          fullWidth: true,
          item1: "email",
        },
        {
          fullWidth: true,
          item1: "companyName",
        },
        {
          fullWidth: true,
          item1: "companyAddress",
        },

      ],
      mortgageDetails: [
        {
          fullWidth: true,
          item1: "financingBank",
        },
        {
          fullWidth: true,
          item1: "financingRefNo",
        },
        {
          fullWidth: true,
          item1: "financed",
        },
        {
          fullWidth: true,
          item1: "financingAmount",
        },
        {
          fullWidth: true,
          item1: "loanTerm",
        },
        {
          fullWidth: true,
          item1: "defermentPeriod",
        },
        {
          fullWidth: true,
          item1: "coverageTerm",
        },
        {
          fullWidth: true,
          item1: "benefit",
        },
        {
          fullWidth: true,
          item1: "criticalIllnessSumCovered",
        },
        {
          fullWidth: true,
          item1: "initialSumCovered",
        },
        {
          fullWidth: true,
          item1: "contributionAmount",
        },
      ],
      healthStatement: [
        {
          fullWidth: true,
          item1: "isDiagnosedDisease",
        },
        {

          fullWidth: true,
          item1: "isConsultation",
        },
        {
          fullWidth: true,
          item1: "isFollowUp",
        },
      ],
      directCreditDetails: [
        {
          fullWidth: true,
          item1: "accountHolderName",
        },
        {
          fullWidth: true,
          item1: "bankAccNo",
        },
        {
          fullWidth: true,
          item1: "bankName",
        },
      ],
      foreigner: [
        {
          fullWidth: true,
          item1: "arrivalDate",
        },
        {
          fullWidth: true,
          item1: "yearStay",
        },
        {
          fullWidth: true,
          item1: "officialStatus"
        },
        {
          indent: true,
          item1: "officialStatusDetails"
        },
        {
          fullWidth: true,
          item1: "positionExactDuties",
        },
        {
          fullWidth: true,
          item1: "property",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "propertyDetails",
        },
        {
          fullWidth: true,
          item1: "spouseMalaysian",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "spouseOccupation",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "spouseNationality",
        },
        {
          fullWidth: true,
          item1: "spouseReside",
        },
        {
          fullWidth: true,
          item1: "intendTravel",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "intendTravelDetails",
        },
        {
          fullWidth: true,
          item1: "certReason",
        },
      ],
      generalOcc: [
        {
          fullWidth: true,
          item1: "occIndustryEngage",
        },
        {
          fullWidth: true,
          item1: "liftingHeavy",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "liftingHeavyDetails",
        },
        {
          fullWidth: true,
          item1: "undergroundHeight",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "undergroundHeightDetails",
        },
        {
          fullWidth: true,
          item1: "chemicalWorking",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "chemicalWorkingDetails",
        },
        {
          fullWidth: true,
          item1: "highVoltage",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "highVoltageDetails",
        },
        {
          fullWidth: true,
          item1: "machinerary",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "machineraryDetails",
        },
        {
          fullWidth: true,
          item1: "vesselWorking",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "vesselWorkingDetails",
        },
        {
          fullWidth: true,
          item1: "travel",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "travelDetails",
        },
        {
          fullWidth: true,
          item1: "env",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "envDetails",
        },
        {
          fullWidth: true,
          item1: "accident",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "accidentDetails",
        },
        {
          fullWidth: true,
          item1: "affectHealth",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "affectHealthDetails",
        },
        {
          fullWidth: true,
          item1: "yearsWorking",
        },
        {
          fullWidth: true,
          item1: "switchJob",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "switchJobDetails",
        },
      ],
      residentialForeignTravel: [
        {
          fullWidth: true,
          item1: "durationOfResidence",
        },
        {
          fullWidth: true,
          item1: "residenceAddr",
        },
        {
          fullWidth: true,
          item1: "stayTime",
        },
        {
          fullWidth: true,
          item1: "firstVisit",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "firstVisitDetails",
        },
        {
          fullWidth: true,
          item1: "locationRemaining",
        },
        {
          indent: true,
          fullWidth: true,
          item1: "otherStayAddr",
        },
        {
          fullWidth: true,
          item1: "accomType",
        },
        {
          fullWidth: true,
          item1: "accomLocated",
        },
        {
          fullWidth: true,
          item1: "workingCond",
        },
        {
          fullWidth: true,
          item1: "politicCond",
        },
      ],
      oilAndGasOcc: [
        {
          fullWidth: true,
          item1: "occIndustryEngage",
        },
        {
          fullWidth: true,
          item1: "natureOfOccupation",
        },
        {
          fullWidth: true,
          item1: "yearsWorking",
        },
        {
          fullWidth: true,
          item1: "lifting",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "liftingDetails",
        },
        {
          fullWidth: true,
          item1: "chemical",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "chemicalDetails",
        },
        {
          fullWidth: true,
          item1: "equipment",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "equipmentDetails",
        },
        {
          fullWidth: true,
          item1: "explosive",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "explosiveDetails",
        },
        {
          fullWidth: true,
          item1: "voltage",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "voltageDetails",
        },
        {
          fullWidth: true,
          item1: "underwater",
        },
        {
          fullWidth: true,
          item1: "underwaterDetails",
        },
        {
          fullWidth: true,
          item1: "hazard",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "hazardDetails",
        },
        {
          fullWidth: true,
          item1: "accident",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "accidentDetails",
        },
        {
          fullWidth: true,
          item1: "rigSituated",
        },
        {
          fullWidth: true,
          item1: "travelToOilRigPerAnnum",
        },
        {
          fullWidth: true,
          item1: "transportHelicopter",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "transportHelicopterDurationHour",
        },
        {
          fullWidth: true,
          indent: true,
          item1: "transportHelicopterFreqTravel",
        },
        {
          fullWidth: true,
          item1: "otherTransport",
        },
      ],
      uploaded_document: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
      ],
    },
    statusMapping: {
      SUBMITTED: {
        label: 'SUBMITTED',
        display: 'Submitted',
        backgroundColor: '#3DD59833',
        color: "#86C5B3",
      },
      PENDING: {
        label: 'PENDING_REVIEW',
        display: 'Pending',
        backgroundColor: '#FEDEDE',
        color: "#EE7623",
      },
      PENDING_SUBMISSION: {
        label: 'GENERATED',
        display: 'Pending Submission',
        backgroundColor: '#DFF0F4',
        color: "#62B5C6",
      },
      PENDING_REVIEW: {
        label: 'PENDING_REVIEW',
        display: 'Pending Review',
        backgroundColor: '#F9E5D8',
        color: "#E37E3A",
      },
      DRAFT: {
        label: 'DRAFT',
        display: 'Draft',
        backgroundColor: '#FFFAE9',
        color: "#EEBB3D",
      },
      UNDEFINED: {
        label: 'UNDEFINED',
        display: 'Undefined',
        backgroundColor: '#D9D9D9',
        color: "grey",
      },
    },
    optionItem: {
      gender: [
        {
          value: 'Male',
          label: 'Male',
        },
        {
          value: 'Female',
          label: 'Female',
        },
        {
          value: 'Others',
          label: 'Others',
        },
      ],
      relationship: [
        {
          value: 'Spouse',
          label: 'Spouse',
        },
        {
          value: 'Child',
          label: 'Child',
        },
        {
          value: 'Parent',
          label: 'Parent',
        },
        {
          value: 'Sibling',
          label: 'Sibling',
        },
      ],
      cardType: [
        {
          value: 'Visa',
          label: 'Visa',
        },
        {
          value: 'MasterCard',
          label: 'MasterCard',
        },
      ],
      incomeRange: [
        {
          value: '< RM25,000',
          label: '< RM25,000',
        },
        {
          value: 'RM25,000 - RM35,999',
          label: 'RM25,000 - RM35,999',
        },
        {
          value: 'RM51,000 - RM75,999',
          label: 'RM51,000 - RM75,999',
        },
        {
          value: 'RM76,000 - RM99,999',
          label: 'RM76,000 - RM99,999',
        },
        {
          value: 'RM100,000 - RM149,999',
          label: 'RM100,000 - RM149,999',
        },
        {
          value: 'RM150,000 - RM200,000',
          label: 'RM150,000 - RM200,000',
        },
        {
          value: '> RM200,000',
          label: '> RM200,000',
        },
      ],
      maritalStatus: [
        {
          value: 'Single',
          label: 'Single',
        },
        {
          value: 'Married',
          label: 'Married',
        },
        {
          value: 'Widowed',
          label: 'Widowed',
        },
        {
          value: 'Divorced',
          label: 'Divorced',
        },
      ],
      race: [
        {
          value: 'Malay',
          label: 'Malay',
        },
        {
          value: 'Chinese',
          label: 'Chinese',
        },
        {
          value: 'Indian',
          label: 'Indian',
        },
        {
          value: 'Others',
          label: 'Others',
        },
      ],
      religion: [
        {
          value: 'Muslim',
          label: 'Muslim',
        },
        {
          value: 'Non Muslim',
          label: 'Non Muslim',
        },
      ],
      pregnancyMonth: [
        {
          value: '1',
          label: '1 month',
        },
        {
          value: '2',
          label: '2 months',
        },
        {
          value: '3',
          label: '3 months',
        },
        {
          value: '4',
          label: '4 months',
        },
        {
          value: '5',
          label: '5 months',
        },
        {
          value: '6',
          label: '6 months',
        },
        {
          value: '7',
          label: '7 months',
        },
        {
          value: '8',
          label: '8 months',
        },
        {
          value: '9',
          label: '9 months',
        },
        {
          value: '10',
          label: '10 months',
        },
      ],
    },
    clientReviewMapping: {
      pendingReview: {
        noticeHeader: 'Pending for Client Review',
        noticeContent: 'This document has been sent for client review. Please follow up with the client.',
      }
    },
    emailResendInterval: 180000
  },
  quotation: {
    defaultBank: "BSNAMYK1XXX",
    actions: {
      DRAFT: {
        codes: ["edit", "delete"],
        labels: ["Edit", "Delete"],
        // labels: [Labels.LBL_EDIT, Labels.LBL_DELETE],
        urls: ["quotation_steps/personal_details", "/"],
      },
      PENDING: {
        codes: ["proceedProposal", "viewQuotation", "edit", "delete"],
        labels: ["View", "Update", "Proceed to Proposal", "Delete"],
        // labels: [
        // Labels.LBL_PROCEED_PROPOSAL,
        // Labels.LBL_VIEW_QUOTATION,
        // Labels.LBL_EDIT,
        // Labels.LBL_DELETE,
        // ],
        urls: [
          "select_quotation",
          "quotation",
          "quotation_steps/personal_details",
          "/",
        ],
      },
      GENERATED: {
        codes: ["updateQuotation", "updateProposal"],
        labels: ["Update Quotation", "Update Proposal"],
        // labels: [
        // Labels.LBL_VIEW_PROPOSAL,
        // Labels.LBL_VIEW_QUOTATION,
        // Labels.LBL_EDIT,
        // ],
        urls: ["proposal", "quotation", "quotation_steps/personal_details"],
      },
      PENDING_SUBMITTED: {
        codes: ["viewQuotation", "viewProposal"],
        labels: ["View Quotation", "View Proposal"],
        // labels: [
        // Labels.LBL_VIEW_PROPOSAL,
        // Labels.LBL_VIEW_QUOTATION,
        // Labels.LBL_EDIT,
        // ],
        urls: ["quotation_details", "proposal_details"],
      },
      UNDEFINED: {
        codes: ["undefined"],
        // labels: [Labels.LBL_UNDEFINED],
        urls: [""],
      },
    },
    optionItem: {
      additionalID: [
        {
          value: 'oldIcNo',
          label: 'Old IC No.',
        },
        {
          value: 'birthCertNo',
          label: 'Birth Certificate No.',
        },
      ],
      financingInstitution: [
        {
          value: 'Alliance Islamic Bank Berhad',
          label: 'Alliance Islamic Bank Berhad',
        },
        {
          value: 'Alliance Bank Malaysia Berhad',
          label: 'Alliance Bank Malaysia Berhad',
        },
      ],
      paymentMethod: [
        {
          value: 'DIRECT',
          label: 'Direct Transfer',
        },
        {
          value: 'CREDIT',
          label: 'Credit Card',
        },
      ],
      gender: [
        {
          value: 'Male',
          label: 'Male',
        },
        {
          value: 'Female',
          label: 'Female',
        },
      ],
      title: [
        {
          value: 'Mr',
          label: 'Mr',
        },
        {
          value: 'Mrs',
          label: 'Mrs',
        },
        {
          value: 'Miss',
          label: 'Miss',
        },
        {
          value: 'Ms',
          label: 'Ms',
        },
        {
          value: 'Dr',
          label: 'Dr',
        },
      ],
      idType: [
        {
          value: 'IC',
          label: 'IC',
        },
        {
          value: 'Police/Army',
          label: 'Police/Army',
        },
        {
          value: 'Foreigner - Passport No.',
          label: 'Foreigner - Passport No.',
        },
      ],
      occupationClass: [
        {
          value: '1',
          label: '1',
        },
        {
          value: '2',
          label: '2',
        },
        {
          value: '3',
          label: '3',
        },
        {
          value: '4',
          label: '4',
        },
        {
          value: '5',
          label: '5',
        },
        {
          value: '6',
          label: '6',
        },
      ],
      loanTerm: Array.from({ length: 31 }, (_, i) => ({
        value: String(i + 5),
        label: `${i + 5} Years`
      })),
      defermentPeriod: [
        {
          value: '0',
          label: '0',
        },
        {
          value: '1',
          label: '1',
        },
        {
          value: '2',
          label: '2',
        },
        {
          value: '3',
          label: '3',
        },
        {
          value: '4',
          label: '4',
        },
      ],
      statusInMalaysia: [
        {
          value: 'Employment Pass',
          label: 'Employment Pass',
        },
        {
          value: 'Dependant\'s Pass',
          label: 'Dependant\'s Pass',
        },
        {
          value: 'Student\'s Pass',
          label: 'Student\'s Pass',
        },
        {
          value: 'Long term social visit pass',
          label: 'Long term social visit pass',
        },
        {
          value: 'Holder of "Malaysia My Second Home" program',
          label: 'Holder of "Malaysia My Second Home" program',
        },
        {
          value: 'Residence pass',
          label: 'Residence pass',
        },
        {
          value: 'Others',
          label: 'Others',
        },

      ],
      accommodationType: [
        {
          value: 'In a house, an apartment, or hotel',
          label: 'In a house, an apartment, or hotel',
        },
        {
          value: 'In a shared accommodation',
          label: 'In a shared accommodation',
        },
        {
          value: 'In a camp, barrack, or a hut?',
          label: 'In a camp, barrack, or a hut?',
        },
        {
          value: 'Other accommodation?',
          label: 'Other accommodation?',
        },
      ],
      liveWorkCondition: [
        {
          value: 'Very good',
          label: 'Very good',
        },
        {
          value: 'Average and in line with the prevailing national standards',
          label: 'Average and in line with the prevailing national standards',
        },
        {
          value: 'Inadequate and problematic',
          label: 'Inadequate and problematic',
        },
      ],
      politicCondition: [
        {
          value: 'Stable',
          label: 'Stable',
        },
        {
          value: 'Civil commotion, tribal warface',
          label: 'Civil commotion, tribal warface',
        },
        {
          value: 'Civil war, war',
          label: 'Civil war, war',
        },

      ],

    },
    dataTableCollumnMapping: [
      {
        // title: Labels.LBL_REF_NO,
        key: "refNo",
        dataIndex: "refNo",
      },
      {
        // title: Labels.LBL_CLIENT_NAME,
        key: "fullName",
        dataIndex: "fullName",
      },
      {
        // title: Labels.LBL_ID_NO,
        key: "idNo",
        dataIndex: "idNo",
      },
      {
        // title: Labels.LBL_CREATION_DATE,
        key: "cms_createdOn",
        dataIndex: "cms_createdOn",
      },
      {
        // title: Labels.LBL_LAST_UPDATED,
        key: "cms_updatedOn",
        dataIndex: "cms_updatedOn",
      },
      {
        // title: Labels.LBL_STATUS,
        key: "trxStatus",
        dataIndex: "trxStatus",
      },
      {
        title: "",
        key: "action",
        dataIndex: "action",
      },
    ],
    dataMapping: {
      body: [
        {
          item: {
            // caption: Labels.LBL_REF_NO,
            value: "refNo",
          },
        },
        {
          item: {
            // caption: Labels.LBL_ID_NO,
            value: "id",
          },
        },
      ],
      footer: [
        {
          item: {
            // caption: Labels.LBL_CREATION_DATE,
            value: "cms_createdOn",
          },
        },
        {
          item: {
            // caption: Labels.LBL_LAST_UPDATED,
            value: "cms_updatedOn",
          },
        },
      ],
    },
    tabBarMapping: {
      all: {
        // label: Labels.LBL_ALL,
        value: "ALL",
      },
      // generated: { label: Labels.LBL_GENERATED, value: "GENERATED" },
      // pending: { label: Labels.LBL_PENDING, value: "PENDING" },
      // draft: { label: Labels.LBL_DRAFT, value: "DRAFT" },
    },
    statusMapping: {
      GENERATED: {
        label: 'GENERATED',
        display: 'Proposal Proceeded',
        backgroundColor: '#3DD59833',
        color: "#86C5B3",
      },
      INITIATED: {
        label: 'INITIATED',
        display: 'Initiated',
        backgroundColor: '#F9E5D8',
        color: "#E37E3A",
      },
      PENDING: {
        label: 'PENDING',
        display: 'Quotation Created',
        backgroundColor: '#DFF0F4',
        color: "#62B5C6",
      },
      DRAFT: {
        label: 'DRAFT',
        display: 'Draft',
        backgroundColor: '#FFFAE9',
        color: "#EEBB3D",
      },
      UNDEFINED: {
        label: 'UNDEFINED',
        display: 'Undefined',
        backgroundColor: '#D9D9D9',
        color: "grey",
      },
    },
    formLabelMapping: {
      personalDetails: {
        label: 'PERSONAL_DETAILS'
      },
      financingDetails: {
        label: 'FINANCING_DETAILS'
      },
      takafulDetails: {
        label: 'TAKAFUL_DETAILS'
      }
    },
    formDataMapping: {
      personalDetails: {
        name: '',
        idType: {
          code: ''
        },
        idNo: '',
        otherIdNo: '',
        gender: '',
        dob: '',
        anb: '',
        occupationClass: '',
        occupation: '',
        natureOfBusiness: '',
        smoker: '',
        quotationDate: '',
        addIDType: '',
        oldIcNo: '',
        birthCertNo: '',
      },
      financialDetails: {
        financingBank: "",
        financingReferenceNo: "",
        financed: "",
        financingAmount: "",
        profitRate: "",
        coveredFinancingAmount: "",
        loanTerm: "",
        defermentPeriod: "",
        // financingPeriod: "",
        // financingPercentage: "",
        criticalIllnessProtection: "",
        criticalIllnessBenefit: "",
      },
      takafulDetails: {
        coverageTerm: '',
        initialSumCovered: '',
        totalSingleContribution: '',
        criticalIllnessSumCovered: '',
      }
    },
    dataDetailMapping: {
      personalDetails: [
        {
          item1: "name",
          item2: "gender",
        },
        {
          item1: "typeId",
          item2: "idNo",
        },
        {
          item1: "addIDType",
          item2: "addId",
        },
        {
          item1: "dob",
          item2: "anb",
        },
        {
          item1: "occupation",
          item2: "natureOfBusiness",
        },
        {
          item1: "occupationGroupCode",
          item2: "occupationClass",
        },
        {
          item1: "smokerStatus",
        },
        {
          item1: "dateOfQuotation",
        },

      ],
      financialDetails: [
        {
          item1: "financingBank",
          // item2: "financingAmount",
        },
        {
          item1: "financed",
          item2: "paymentMethod",
        },
        {
          item1: "profitRate",
          item2: "coveredFinancingAmount",
        },
        {
          item1: "loanTerm",
          item2: "defermentPeriod",
        },
        {
          item1: "criticalIllnessProtection",
          item2: "criticalIllnessBenefit",
        },
      ],
      takafulDetails: [
        {
          item1: "coverageTerm",
          // item1: "termOfCoverage",

        },
        {
          item1: "initialSumCovered",
          item2: "totalSingleContribution",
        },
        {
          item1: "criticalIllnessSumCovered",
        },
      ],
      uploaded_document: [
        {
          item1: "termOfCoverage",
          item2: "initialSumCovered",
        },
        {
          item1: "contributionAmount",
          item2: "contributionMode",
        },
      ],
    },
  },
  formProposalDetailMapping: [
    {
      category: "PERSONAL_DETAILS",
      field: "personalDetails",
    },
    {
      category: "MORTGAGE_DETAILS",
      field: "mortgageDetails",
    },
    {
      category: "HEALTH_DETAILS",
      field: "healthDetails",
    },
    {
      category: "EXTENDED_HEALTH_DETAILS",
      field: "extendedHealthDetails",
    },
    {
      category: "FOREIGNER_QUESTIONNAIRE_DETAILS",
      field: "foreignerQuestionnaireDetails",
    },
    {
      category: "GENERAL_OCCUPATION_DETAILS",
      field: "generalOccupationDetails",
    },
    {
      category: "OIL_GAS_DETAILS",
      field: "oilGasDetails",
    },
    {
      category: "RES_TRAVEL_DETAILS",
      field: "residentialTravelDetails",
    },
    {
      category: "DIRECT_CREDIT_DETAILS",
      field: "directCreditDetails",
    },
    {
      category: "AGENT_CONSENT_DETAILS",
      field: "agentConsentDetails",
    },
    {
      category: "THIRD_PARTY_CONSENT",
      field: "thirdPartyConsent",
    },
    {
      category: "SUBMIT_REVIEW_DETAILS",
      field: "submitReviewDetails",
    },
    {
      category: "CREDIT_CARD_PAYMENT_DETAILS",
      field: "creditCardPaymentDetails",
    },
    {
      category: "PAYOR_DETAILS",
      field: "payorDetails",
    },
  ],
  occupationClassData: {
    occupationTableColumn: [
      {
        title: 'Occupation Group',
        dataIndex: 'occupationGrp',
        key: 'occupationGrp',
      },
      {
        title: 'Description',
        dataIndex: 'desc',
        key: 'desc',
      },
    ],
    occupationTableData:
      [
        {
          occupationGrp: 'Group 1a',
          desc: 'You are involved in specific business or services. (e.g. ,money services business, pawn shop owner, gambling & etc.) Currency exchange or currency dealer, money transmitter, pawn shop owner, casino operator, retail shop owner, securities dealer, other gambling related establishment. (Requires AML Clearance)'
        },
        {
          occupationGrp: 'Group 1b',
          desc: 'Business Owner, Senior Management, others level of office work or administration work other than specific business or services.Working in an office-type environment and spend a lot time seated or at your desk in an office e.g. administrator, call centre help-desk, office and clerical worker, IT/System service desk, doctor, management positions or senior-level executives, CEO'
        },
        {
          occupationGrp: 'Group 1c',
          desc: 'Profession in specific business or services (e.g. accountant, company secretary, lawyer, property agent or developer.'
        },
        {
          occupationGrp: 'Group 2',
          desc: 'Sales or light manual work: Your job involves light manual duties or local, travel (but not delivering goods) e.g. waiter/waitress, sales, retail shop, worker, nurse, cleaner, factory supervisor with light duties, engineer or other, professional who do occasional fieldwork.'
        },
        {
          occupationGrp: 'Group 3',
          desc: 'Manual work but no heavy labour: Your job involves manual labour but requires no heavy lifting, you work mostly indoors and may require a trade, certificate. e.g. bartender, cook, plumber, construction supervisor, driver, gardener and police.'
        },
        {
          occupationGrp: 'Group 4',
          desc: 'Heavy manual labour with or without specialised training: Your job involves, heavy manual labour with some heavy lifting, you may not need specialised, training for your work e.g. mechanic, construction worker (but not at heights), builder, factory worker, labourer and security guard group.'
        },
        {
          occupationGrp: 'Group 5',
          desc: 'Risky occupations: Your job involves any of the following: working to 15 metres or more, working underwater or underground, shipping, off-shore, work or fishing, mining, oil rigs, armed services, coast guard, working with chemicals or explosives, professional sports or non-commercial pilot.'
        },
        {
          occupationGrp: 'Group 6',
          desc: 'Not in paid employment: You are	not	in paid employment e.g. Housewife, Homemaker, Student, Retiree or not currently employed.'
        },
      ],
  },
  HSBC: {
    proposal: {
      contributionDueDetails: [
        "holidayIndicator",
        "dueAmount",
        "dueDate",
        "lastContributionDue",
        "dueTerm",
        "additionalCharge",
      ],
      certificateDetailsDate: [
        "proposalSubmissionDate",
        "certAcceptanceDate",
        "riskCommencementDate",
      ],
      certificateDetails: [
        {
          item1: "productName",
          item2: "certStatus",
        },
        {
          item1: "certNum",
          item2: "sumCovered",
        },
        {
          item1: "coverageTerm",
          item2: "agingDays",
        },
        {
          item1: "contribution",
          item2: "contributionFreq",
        },
        {
          item1: "basicContribution",
          item2: "riderContribution",
        },
        {
          item1: "regularTopupContribution",
          item2: null,
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "regionCode",
          item2: "regionName",
        },
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
      ],
    },
    certificateCollection: {
      contributionDueDetails: [
        "holidayIndicator",
        "dueAmount",
        "dueDate",
        "lastContributionDue",
        "dueTerm",
        "additionalCharge",
      ],
      certificateDetailsDate: [
        "riskCommencementDate",
        "issuedDate",
        "contributionCessationDate",
        "maturityDate",
      ],
      certificateDetails: [
        {
          item1: "productName",
          item2: "certStatus",
        },
        {
          item1: "certNum",
          item2: "sumCovered",
        },
        {
          item1: "coverageTerm",
        },
        {
          item1: "contribution",
          item2: "contributionFreq",
        },
        {
          item1: "basicContribution",
          item2: "riderContribution",
        },
        {
          item1: "totalCollectedContribution",
          item2: "annualisedContribution",
        },
        {
          item1: "regularTopupContribution",
          item2: "totalAdhocTopupContribution",
        },
        {
          item1: "contributionPaymentTerm",
          item2: "paymentType",
        },
        {
          item1: "cashValue",
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "regionCode",
          item2: "regionName",
        },
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
      ],
    },
    issuedCase: {
      contributionDueDetails: ["dueAmount", "dueDate"],
      certificateDetailsDate: [
        "riskCommencementDate",
        "issuedDate",
        "contributionCessationDate",
        "maturityDate",
      ],
      certificateDetails: [
        {
          item1: "productName",
          item2: "certStatus",
        },
        {
          item1: "certNum",
          item2: "sumCovered",
        },
        {
          item1: "coverageTerm",
        },
        {
          item1: "contribution",
          item2: "contributionFreq",
        },
        {
          item1: "basicContribution",
          item2: "riderContribution",
        },
        {
          item1: "totalCollectedContribution",
          item2: "annualisedContribution",
        },
        {
          item1: "regularTopupContribution",
          item2: "totalAdhocTopupContribution",
        },
        {
          item1: "contributionPaymentTerm",
          item2: "paymentType",
        },
        {
          item1: "cashValue",
          item2: "regularPayoutIndicator",
        },
        {
          item1: "regularPayoutAmt",
          item2: "regularPayoutFreq",
        },
        {
          item1: "regularPayoutCount",
          item2: null,
        },
      ],
      beneficiaryDetails: [
        {
          item1: "name",
          item2: "id",
          item3: "relationship",
          item4: "sharePercentage",
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "regionCode",
          item2: "regionName",
        },
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
      ],
    },
    businessOpportunity: {
      certificateDetailsDate: [
        "contPaidUpDate",
        "firstRegularPayoutDate",
        "maturityDate",
      ],
      certificateDetails: [
        {
          item1: "productName",
          item2: "certStatus",
        },
        {
          item1: "certNum",
          item2: "sumCovered",
        },
        {
          item1: "coverageTerm",
          item2: "coveragePeriod",
        },
        {
          item1: "contribution",
          item2: "contributionFreq",
        },
        {
          item1: "basicContribution",
          item2: "riderContribution",
        },
        {
          item1: "totalCollectedContribution",
          item2: "annualisedContribution",
        },
        {
          item1: "regularTopupContribution",
          item2: "totalAdhocTopupContribution",
        },
        {
          item1: "contributionPaymentTerm",
          item2: "paymentType",
        },
        {
          item1: "cashValue",
          item2: "surrenderValue",
        },
        {
          item1: "regularPayoutAmt",
          item2: "regularPayoutFreq"
        },
        {
          item1: "regularPayoutIndicator",
          item2: null
        }
      ],
      certificateDetailsFullyPaidUp: [
        {
          item1: "productName",
          item2: "certStatus",
        },
        {
          item1: "certNum",
          item2: "sumCovered",
        },
        {
          item1: "coverageTerm",
          item2: "coveragePeriod",
        },
        {
          item1: "contribution",
          item2: "contributionFreq",
        },
        {
          item1: "basicContribution",
          item2: "riderContribution",
        },
        {
          item1: "totalCollectedContribution",
          item2: "annualisedContribution",
        },
        {
          item1: "regularTopupContribution",
          item2: "totalAdhocTopupContribution",
        },
        {
          item1: "contributionPaymentTerm",
          item2: "paymentType",
        },
        {
          item1: "cashValue",
          item2: "surrenderValue",
        },
        {
          item1: "regularPayoutAmt",
          item2: "regularPayoutFreq"
        },
        {
          item1: "regularPayoutIndicator",
          item2: "regularPayoutCount"
        }
      ],
      certificateDetailsMatured: [
        {
          item1: "productName",
          item2: "certStatus",
        },
        {
          item1: "certNum",
          item2: "sumCovered",
        },
        {
          item1: "coverageTerm",
          item2: "coveragePeriod",
        },
        {
          item1: "contribution",
          item2: "contributionFreq",
        },
        {
          item1: "basicContribution",
          item2: "riderContribution",
        },
        {
          item1: "totalCollectedContribution",
          item2: "annualisedContribution",
        },
        {
          item1: "regularTopupContribution",
          item2: "totalAdhocTopupContribution",
        },
        {
          item1: "contributionPaymentTerm",
          item2: "paymentType",
        },
        {
          item1: "cashValue",
          item2: "surrenderValue",
        },
        {
          item1: "regularPayoutAmt",
          item2: "regularPayoutFreq"
        },
        {
          item1: "regularPayoutIndicator",
          item2: "regularPayoutCount"
        },
        {
          item1: "maturityPayoutAmt",
          item2: "totalMaturityValue",
        }
      ],
      bankRepresentativeDetails: [
        {
          item1: "regionCode",
          item2: "regionName",
        },
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
      ],
    },
    claim: {
      contributionDueDetails: [
        "holidayIndicator",
        "dueAmount",
        "dueDate",
        "lastContributionDue",
        "dueTerm",
        "additionalCharge",
      ],
      certificateDetailsDate: ["riskCommencementDate", "issuedDate"],
      certificateDetails: [
        {
          item1: "productName",
          item2: null,
        },
        {
          item1: "certNum",
          item2: "sumCovered",
        },
        {
          item1: "coverageTerm",
          item2: "coveragePeriod",
        },
        {
          item1: "tpdClaimStatus",
          item2: "tpdCriticalIllnessIndicator",
        },
        {
          item1: "criticalIllnessRiderSumCovered",
          item2: null,
        },
      ],
      claimDetails: [
        {
          item1: "claimRefNo",
          item2: "claimSubmissionDate",
        },
        {
          item1: "claimType",
          item2: "claimStatus",
        },
        {
          item1: "lastUpdatedDate",
          item2: null,
        },
        {
          item1: "participantName",
          item2: "participantId",
        },
        {
          item1: "participantMobileNum",
          item2: "participantEmail",
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "regionCode",
          item2: "regionName",
        },
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
      ],
    },
  },
  Alliance: {
    proposal: {
      contributionDueDetails: [
        "holidayIndicator",
        "dueAmount",
        "dueDate",
        "lastContributionDue",
        "dueTerm",
        "additionalCharge",
      ],
      certificateDetailsDate: [
        "proposalSubmissionDate",
        "certAcceptanceDate",
        "riskCommencementDate",
      ],
      certificateDetails: [
        {
          item1: "productName",
          item2: "bankRefNum",
        },
        {
          item1: "certNum",
          item2: "certStatus",
        },
        {
          item1: "sumCovered",
          item2: "contribution",
        },
        {
          item1: "criticalIllnessRider",
          item2: "criticalIllnessIndicator",
        },
        {
          item1: "criticalIllnessRiderSumCovered",
          item2: null,
        },
        {
          item1: "certTerm",
          item2: "constructionYear",
        },
        {
          item1: "paymentType",
          item2: "agingDays",
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
        {
          item1: "rptMgrName",
        },
      ],
    },
    issuedCase: {
      contributionDueDetails: ["dueAmount", "dueDate"],
      certificateDetailsDateInForce: ["proposalSubmissionDate", "riskCommencementDate", "issuedDate"],
      certificateDetailsDateAccepted: ["proposalSubmissionDate", "certAcceptanceDate", "riskCommencementDate"],
      certificateDetailsInForce: [
        {
          item1: "productName",
          item2: "bankRefNum",
        },
        {
          item1: "certNum",
          item2: "certStatus",
        },
        {
          item1: "sumCovered",
          item2: "contribution",
        },
        {
          item1: "criticalIllnessRider",
          item2: "criticalIllnessIndicator",
        },
        {
          item1: "criticalIllnessRiderSumCovered",
          item2: null,
        },
        {
          item1: "certTeam",
          item2: "constructionYear",
        },
        {
          item1: "paymentType",
          item2: null,
        },
      ],
      certificateDetailsAccepted: [
        {
          item1: "productName",
          item2: "bankRefNum",
        },
        {
          item1: "certNum",
          item2: "certStatus",
        },
        {
          item1: "sumCovered",
          item2: "contribution",
        },
        {
          item1: "criticalIllnessRider",
          item2: "criticalIllnessIndicator",
        },
        {
          item1: "criticalIllnessRiderSumCovered",
          item2: null,
        },
        {
          item1: "certTeam",
          item2: "constructionYear",
        },
        {
          item1: "paymentType",
          item2: "agingDays",
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
        {
          item1: "rptMgrName",
        },
      ],
    },
    claim: {
      contributionDueDetails: [
        "holidayIndicator",
        "dueAmount",
        "dueDate",
        "lastContributionDue",
        "dueTerm",
        "additionalCharge",
      ],
      certificateDetailsDate: ["riskCommencementDate", "issuedDate"],
      certificateDetails: [
        {
          item1: "productName",
          item2: "bankRefNum",
        },
        {
          item1: "certNum",
          item2: null,
        },
        {
          item1: "sumCovered",
          item2: "contribution",
        },
        {
          item1: "criticalIllnessRider",
          item2: "criticalIllnessIndicator",
        },
        {
          item1: "criticalIllnessRiderSumCovered",
          item2: null,
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
        {
          item1: "rptMgrName",
        },
      ],
    },
  },
  MBSB: {
    proposal: {
      contributionDueDetails: [
        "holidayIndicator",
        "dueAmount",
        "dueDate",
        "lastContributionDue",
        "dueTerm",
        "additionalCharge",
      ],
      certificateDetailsDate: [
        "proposalSubmissionDate",
        "certAcceptanceDate",
        "riskCommencementDate",
      ],
      certificateDetails: [
        {
          item1: "productName",
          item2: "bankRefNum",
        },
        {
          item1: "certNum",
          item2: "certStatus",
        },
        {
          item1: "sumCovered",
          item2: "contribution",
        },
        {
          item1: "criticalIllnessRider",
          item2: "criticalIllnessIndicator",
        },
        {
          item1: "criticalIllnessRiderSumCovered",
          item2: null,
        },
        {
          item1: "certTerm",
          item2: "constructionYear",
        },
        {
          item1: "paymentType",
          item2: "agingDays",
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
        {
          item1: "rptMgrName",
        },
      ],
    },
    issuedCase: {
      contributionDueDetails: ["dueAmount", "dueDate"],
      certificateDetailsDateInForce: ["proposalSubmissionDate", "riskCommencementDate","issuedDate"],
      certificateDetailsDateAccepted: [ "proposalSubmissionDate","certAcceptanceDate","riskCommencementDate"],
      certificateDetailsInForce: [
        {
          item1: "productName",
          item2: "bankRefNum",
        },
        {
          item1: "certNum",
          item2: "certStatus",
        },
        {
          item1: "sumCovered",
          item2: "contribution",
        },
        {
          item1: "criticalIllnessRider",
          item2: "criticalIllnessIndicator",
        },
        {
          item1: "criticalIllnessRiderSumCovered",
          item2: null,
        },
        {
          item1: "certTeam",
          item2: "constructionYear",
        },
        {
          item1: "paymentType",
          item2: null,
        },
      ],
      certificateDetailsAccepted: [
        {
          item1: "productName",
          item2: "bankRefNum",
        },
        {
          item1: "certNum",
          item2: "certStatus",
        },
        {
          item1: "sumCovered",
          item2: "contribution",
        },
        {
          item1: "criticalIllnessRider",
          item2: "criticalIllnessIndicator",
        },
        {
          item1: "criticalIllnessRiderSumCovered",
          item2: null,
        },
        {
          item1: "certTeam",
          item2: "constructionYear",
        },
        {
          item1: "paymentType",
          item2: "agingDays",
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
        {
          item1: "rptMgrName",
        },
      ],
    },
    claim: {
      contributionDueDetails: [
        "holidayIndicator",
        "dueAmount",
        "dueDate",
        "lastContributionDue",
        "dueTerm",
        "additionalCharge",
      ],
      certificateDetailsDate: ["riskCommencementDate", "issuedDate"],
      certificateDetails: [
        {
          item1: "productName",
          item2: "bankRefNum",
        },
        {
          item1: "certNum",
          item2: null,
        },
        {
          item1: "sumCovered",
          item2: "contribution",
        },
        {
          item1: "criticalIllnessRider",
          item2: "criticalIllnessIndicator",
        },
        {
          item1: "criticalIllnessRiderSumCovered",
          item2: null,
        },
      ],
      bankRepresentativeDetails: [
        {
          item1: "branchCode",
          item2: "branchName",
        },
        {
          item1: "agentId",
          item2: "agentName",
        },
        {
          item1: "rptMgrName",
        },
      ],
    },
  },
  labelPrefix: {
    errorTitle: "ERRTITLE_",
    errorDesc: "ERRDESC_",
  },
  cache: {
    languageKey: "fwdbanca_SELECTED_LANG",
    localeKey: "fwdbanca_LOCALE_LIBRARY",
    sessionID: "SESSIONID_",
    productScreens: "fwdbanca_PRODUCT_SCREENS_",
    screenDetail: "fwdbanca_SCREEN_DETAIL_",
    partnerDetail: "fwdbanca_PARTNER_DETAIL_",
  },
  client: {
    type: {
      customer: "CUSTOMER",
      payor: "PAYOR",
    },
    idType: {
      nric: "NRIC",
      passport: "Passport",
    },
    gender: {
      male: "Male",
      female: "Female",
    },
    declaration: [
      <>The information given in this proposal and any information supplied to FWD Takaful Berhad, FWD Takaful representative or FWD Takaful Medical Examiner (if applicable) are true, and all facts disclosed are to the best of my knowledge and in good faith and that no material information has been withheld and it shall be the basis of the contract for the takaful cover. I understand that this duty of disclosure shall continue until the time the certificate is issued, varied or renewed, whereby any failure in my part to do so may result in a variation of the certificate in part or in whole.</>,
      <>I understand that within the first twelve (12) months from the coverage effective date, no benefit is payable if the Pre-Existing Condition is the material cause of death or total and permanent disability. Pre-Existing Condition shall mean any injury or illness which existed, have developed symptoms, existing illness manifestation or pathological development prior to the certificate effective date. Any death or total and permanent disability claim caused by Pre-Existing Condition which is unknown to FWD Takaful after the twelve (12) months will be handled in accordance with the Islamic Financial Services Act (IFSA) 2013. (Note: Pre-Existing Condition full definition is stated in the Master Certificate Summary document).  <b>Note: Only applicable for full underwriting assessment.</b></>,
      <>I understand that within the first twelve (12) months from the coverage effective date, no benefit is payable if the Pre-Existing Condition <b>(including condition(s) unknown and / or made known to FWD Takaful)</b> is the material cause of death or total and permanent disability. Pre-Existing Condition shall mean any injury or illness which existed, have developed symptoms, existing illness manifestation or pathological development prior to the certificate effective date. <b>(Note: Pre-Existing Condition full definition is stated in the Master Certificate Summary document).</b> Note: Only applicable if you are entitled for free cover limit.</>,
      <>I acknowledge that if I fail to declare truthfully, FWD Takaful has the right to cancel the takaful coverage or reject my claim applications.</>,
      <>I am aware that my takaful coverage will not begin unless and until FWD Takaful have given me a written approval and issued the relevant certificate indicating my cover has commenced.</>,
      <>I fully understand that the financing bank is the Participant for this plan. In the event of a claim arising from the plan, all claim monies are payable to the Participant for the purpose of reducing or paying off my outstanding financing with the Participant. The balance (if any), will be payable by the Participant to me (if still alive) or to my estate in the event of my demise.</>,
      <>I have studied the product disclosure sheet, brochures (if any), product illustrations (if any), other marketing materials (if any) and understood to the benefits which are guaranteed and not guaranteed.</>,
      <>I hereby authorise FWD Takaful to invest monies from my Individual Special Account (ISA) on my behalf. I agree that the investment profit (if any) from the ISA will be shared between me and FWD Takaful, based on the Mudarabah principles where I will receive 80% and the remaining 20% will go to FWD Takaful at the end of each financial year. My investment profit portion will be placed back into my ISA accordingly.</>,
      <>I understand that I am entitled to receive 50% of the distributable surplus (if any), inclusive of the investment returns, arising from the Tabarru` Fund after the end of each financial year and such amount will be credited directly into ISA. I will allow FWD Takaful to take 50% of the distributable surplus (if any) as performance fee for managing the Tabarru` Fund. The exact amount of the distributable surplus is to be determined annually and subject to approval by both of FWD Takaful’s Shariah Committee and Board of Directors.</>,
      <>I agree that all costs, expenses, charges and levies for maintaining the assets / monies of the Tabarru` Fund and the ISA, as the case may be, and any other related expenses shall be borne by and paid from the Tabarru` Fund and ISA respectively.</>,
      <>Taxes at the prevailing rate may be charged on any of the contributions, or any other payments due (where applicable under local Malaysian taxation laws) under this takaful certificate.</>,
      <>I understand and agree that should there be a request of reprinting certificate document, the admin charges shall be borne by me.</>,
    ]
  },
  routes: {
    assetsContext: "/portal",
    entity: {
      hsbc: "hsbc",
      alliance: "alliance",
      mbsb:"mbsb",
    },
    generic: {
      login: "login",
      resetPassword: "reset-password",
      changePassword: "change-password",
      account: "account",
      profile: "profile",
      home: "home",
      connectivity: "connectivity",
      dailyReminder: "daily-reminders",
      announcement: "announcement",
      mrtt: "mrtt",
      fwd: "fwd",

      client_auth: 'client/authentication',
      invalid: 'client/invalid_link',
      expired: 'client/expired_link',
      client_otp: 'client/verification',
      client_review_proposal: 'client/review/proposal',
      client_review_declaration: 'client/review/declaration',
      client_review_signature: 'client/review/signature',
      client_review_success: 'client/review/success',
      client_review_read_declaration: 'client/review/read_declaration',

      quotation: "quotation",
      quotation_details: "quotation_details",
      quotation_personal_details: "quotation_steps/personal_details",
      quotation_financial_details: "quotation_steps/financial_details",
      quotation_takaful_details: "quotation_steps/takaful_details",
      quotation_review_submit: "quotation_steps/review_submit",
      quotation_selection: "quotation_selection",

      proposal: "proposal",
      proposal_details: "proposal_details",
      proposal_form: 'proposal_form',
      proposal_provide_details: "proposal_steps/provide_details",
      proposal_upload_documents: "proposal_steps/upload_documents",
      proposal_review: "proposal_steps/review",
      proposal_consent_declaration: "proposal_steps/consent_declaration",

      faq: 'faq',
      document: "document",
      issuedCase: "issued-case",
      certificateCollection: "certificate-collection",
      certificateCollectionUpcoming: "certificate-collection-upcoming",
      claim: "claim",
      businessOpportunity: "business-opportunity",
      businessOpportunityUpcoming: "business-opportunity-upcoming",
      form: "form",
      loginAdmin: "login-admin",
    },
    journey: {
      personalDetail: "personalDetail",
    },
  },
  error: {
    labelNotFound: "<Missing label>",
  },
  searchCriteriaValidationType: {
    //1 = no symbols
    //2 = no numbers
    //3 = no letters & symbols
    //4 = no validation
    certificateNumber: 1,
    participantName: 2,
    participantId: 1,
    mobileNumber: 3,
    coveredName: 2,
    coveredId: 1,
    claimRefNo: 4,
    bankReferenceNumber: 4,
  },
};

export default Config;
